import { inject } from '@angular/core'
import { AuthService } from '@shared-services/auth.service'
import { TvEntryContext } from './tv-entry-context'

export const initializeAuthSession = (): Promise<boolean> => inject(TvEntryContext).isolatedBootstrap()
  ? Promise.resolve(false)
  : inject(AuthService).restoreRememberedSession()
